import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/pages/Dashboard/Dashboard/Overview.vue'

// Pages
import Profile from 'src/pages/Dashboard/Pages/UserProfile.vue'
import TimeLine from 'src/pages/Dashboard/Pages/TimeLinePage.vue'
import Login from 'src/pages/Dashboard/Pages/Login.vue'
import Signup from 'src/pages/Dashboard/Pages/Signup.vue'
import XlsImporter from 'src/pages/Dashboard/Pages/XlsImporter.vue'
import Investments from 'src/pages/Dashboard/Pages/Investments.vue'
import Search from 'src/pages/Dashboard/Pages/Search.vue'
import CompanyProfile from 'src/pages/Dashboard/Pages/CompanyProfile.vue'
import ChecklistDetails from 'src/pages/Dashboard/Pages/ChecklistDetails.vue'
import CompanyAdd from 'src/pages/Dashboard/Pages/CompanyCreate.vue'
import CompanyEdit from 'src/pages/Dashboard/Pages/CompanyEdit.vue'
import Transactions from 'src/pages/Dashboard/Pages/Transactions.vue'
import Loading from 'src/pages/Dashboard/Pages/Loading.vue'
import Invite from 'src/pages/Dashboard/Pages/Invite.vue'
import Role from 'src/pages/Dashboard/Pages/Role.vue'
import EditProfile from 'src/pages/Dashboard/Pages/UserProfile/EditProfileForm.vue'
import AddUser from 'src/pages/Dashboard/Pages/AddUser.vue'
import ForgotPassword from 'src/pages/Dashboard/Pages/ForgotPassword.vue'
import Team from 'src/pages/Dashboard/Pages/Team.vue'
import Todo from 'src/pages/Dashboard/Pages/Todos.vue'
import TestPage from 'src/pages/Dashboard/Pages/testpage.vue'
import Diligence from 'src/pages/Dashboard/Pages/diligence.vue'
import People from 'src/pages/Dashboard/Pages/People.vue'
import Workspace from 'src/pages/Dashboard/Pages/Workspace.vue'
import UserAnalytics from 'src/pages/Dashboard/Pages/UserAnalytics.vue'
import SharedPortfolio from 'src/pages/Dashboard/Pages/SharedPortfolio.vue'
import Payments from 'src/pages/Dashboard/Pages/Payments.vue'
import PaymentsPage from 'src/pages/Dashboard/Pages/PaymentsPage.vue'
import CreateWorkspace from 'src/pages/Dashboard/Pages/CreateWorkspace.vue'
import Documents from 'src/pages/Dashboard/Pages/Documents.vue'
import Thesis from 'src/pages/Dashboard/Pages/Thesis.vue'
import WorkspaceProfile from 'src/pages/Dashboard/Pages/WorkspaceProfile.vue'
import LpEditWorkspace from "src/pages/Dashboard/Pages/LpEditWorkspace.vue"
import LpDashboard from "src/pages/Dashboard/Pages/LpDashboard.vue"
import LpSummary from "src/pages/Dashboard/Pages/LpSummary.vue"
import ProfileSettingNew from 'src/pages/Dashboard/Pages/ProfileSettingNew.vue'
import InvestorPublic from 'src/pages/Dashboard/Pages/InvestorPublic.vue'
import BuyProRata from 'src/pages/Dashboard/Pages/BuyProRata.vue'
import SellProRata from 'src/pages/Dashboard/Pages/SellProRata.vue'
import SPVSummary from 'src/pages/Dashboard/Pages/SPVSummary.vue'
import SPVDashboard from 'src/pages/Dashboard/Pages/SPVDashboard'
import SPVCompanyProfile from 'src/pages/Dashboard/Pages/SPVCompanyProfile'
// pages w/o top & side-nav
const root = {
    path: '/',
    redirect: '/login'
}

const loginPage = {
    path: '/login',
    name: 'Login',
    components: { default: Login }
}
const signupPage = {
    path: '/signup',
    name: 'Signup',
    component: Signup
}

const frgtPswdPage = {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
}
const invitePage = {
    path: '/invite/:uuid/:role_id/:invitedEmail',
    name: 'Invite',
    component: Invite
}

const addUser = {
    path: '/addUser',
    name: 'Add User',
    component: AddUser
}

const sharedPortfolio = {
    path: '/:account_id/shared/company',
    name: 'Shared Portfolio',
    component: SharedPortfolio
}

const paymentsPage = {
    path: '/:account_id/payments',
    name: 'PaymentsPage',
    component: PaymentsPage
}

const workspaceDashboard = {
    path: '/:account_id/workspace',
    name: 'Workspace Dashboard',
    component: Workspace
}

const createWorkspace = {
    path: '/:account_id/create/workspace',
    name: 'Create Workspace',
    component: CreateWorkspace
}

// const profilePage = {
//   path: '/:account_id/profile',
//   name: 'Profile Page',
//   component: Profile
// }
const profilePage = {
    path: '/:account_id/profile',
    name: 'Profile Page',
    component: ProfileSettingNew
}

const testPage = {
    path: '/testPage',
    name: 'Test Page',
    component: TestPage
}

const userAnalyticsPage = {
    path: '/userAnalytics',
    name: 'User Analytics',
    component: UserAnalytics
}

const loadingPage = {
    path: '/loading',
    name: 'Loading Page',
    component: Loading
}

const workspaceProfile = {
    path: '/:account_id/workspace/profile',
    name: 'Workspace Profile',
    component: WorkspaceProfile
}

const lpEditWorkspace = {
    path: '/:account_id/:workspace/edit/workspace',
    name: 'Lp Edit Workspace',
    component: LpEditWorkspace
}

const investorsPublicPage = {
    path: '/investors',
    name: 'Investors Public Page',
    component: InvestorPublic
}

const sellProRata = {
    path: '/:account_id/sell/prorata',
    name: 'Sell Positions',
    component: SellProRata
}

const buyProRata = {
    path: '/:account_id/buy/prorata',
    name: 'Buy Positions',
    component: BuyProRata
}

// pages w/ the top & side-nav
const dashboard = {
    path: '/:account_id/:workspace_id',
    name: 'Dashboard',
    // redirect: '/:account_id/:workspace_id/dashboard/overview',
    component: DashboardLayout,
    children: [{
            path: 'dashboard/overview',
            component: Overview
        },
        {
            path: 'portfolio',
            component: Investments
        },
        {
            path: 'portfolio/import',
            component: XlsImporter
        },
        {
            path: 'portfolio/add',
            component: CompanyAdd
        },
        {
            path: 'portfolio/edit/:ucid',
            component: CompanyEdit
        },
        {
            path: 'search',
            component: Search
        },
        {
            path: 'companyprofile/:ucid',
            component: CompanyProfile
        },
        {
            path: 'checklist/:portfolio_item/:ucid/:checklist_id',
            component: ChecklistDetails
        },
        {
            path: 'transactions',
            component: Transactions
        },
        {
            path: 'profile/edit',
            component: EditProfile
        },
        {
            path: 'team',
            component: Team
        },
        {
            path: 'todos',
            component: Todo
        },
        {
            path: 'people',
            component: People
        },
        {
            path: 'diligence',
            component: Diligence
        },
        {
            path: 'payments',
            component: Payments
        },
        {
            path: 'documents',
            component: Documents
        },
        {
            path: 'thesis',
            component: Thesis
        },
        {
            path: 'lpSummary',
            component: LpSummary
        },
        {
            path: 'lpDashboard',
            component: LpDashboard
        },
        {
            path: 'spvsummary',
            component: SPVSummary
        },
        {
            path: "spvDashboard",
            component: SPVDashboard
        },
        {
            path: 'spvCompanyprofile/:ucid',
            component: SPVCompanyProfile
        },
    ]
}

const routes = [
    root,
    loginPage,
    signupPage,
    workspaceDashboard,
    paymentsPage,
    profilePage,
    loadingPage,
    dashboard,
    addUser,
    invitePage,
    frgtPswdPage,
    testPage,
    userAnalyticsPage,
    sharedPortfolio,
    createWorkspace,
    workspaceProfile,
    lpEditWorkspace,
    investorsPublicPage,
    sellProRata,
    buyProRata,
    { path: '*', component: NotFound }
]

// const routes = [
//   {
//     path: '/',
//     redirect: '/admin'
//   },
//   loginPage,
//   {
//     path: '/admin',
//     component: DashboardLayout,
//     redirect: '/admin/overview',
//     children: [
//       {
//         path: 'overview',
//         name: 'Overview',
//         component: Overview
//       },
//       {
//         path: 'investments',
//         name: 'Investments',
//         component: Investments
//       },
//       {
//         path: 'XlsImporter',
//         name: 'XlsImporter',
//         component: XlsImporter
//       }
//     ]
//   },
//   {path: '*', component: NotFound}
// ]

export { routes }